module.exports = __webpack_public_path__ + "static/media/ic-camera.25b20564.svg";